import { DateTime } from 'luxon'

export enum GolfRole {
  SUPER_ADMIN = 'super_admin',
  ADMIN = 'admin',
  OPERATOR = 'operator',
  VIEWER = 'viewer',
  GOLF_STATISTICS_VIEWER = 'statistics-viewer',
  GOLF_CAR_OWNER = 'golf_car_owner',
  SUPERVISOR = 'supervisor',
}

export enum GolfStatus {
  ACTIVE = 'active',
  INACTIVE = 'inactive',
}

export interface GolfAdmin {
  id: string
  email: string
  golf_role?: GolfRole
  golf_status?: GolfStatus
  role: string // P2P role
  status: string // P2P status
  createdAt: DateTime
  updatedAt: DateTime
}

export interface CreateGolfAdminAccount {
  email: string
  golf_role: GolfRole
}
